<template>
    <div class="popover">
        <div class="sign-wrap">
            <div class="text">选择反馈的问题将标记为已解决！</div>
            <div class="">请对我们的服务做出评价：</div>
            <div class="choose">
                <Radio v-model="score" :label="2">非常满意</Radio>
                <Radio v-model="score" :label="1">一般</Radio>
                <Radio v-model="score" :label="0">非常不满意</Radio>
                <Input placeholder="不满意原因..." type="textarea" :autosize="{minRows:2, maxRows:4}" v-model="backcontent" v-if="score == 0" maxlength="1000"></Input>
            </div>
        </div>
        <div class="btn_box" style="padding-top:30px;">
            <el-button class="btn_add_canle" size="mini" @click="cancel">取消</el-button>
            <el-button class="btn_add_sure" size="mini" type="primary" @click="ok">保存</el-button>
        </div>
    </div>
</template>

<script>
import { Radio, Input } from 'element-ui'
import Message from '../../common/utils/message' 
    import Axios from "@/api/diyaxios";

export default {
    props:[ 'data' ],
    data(){
        return {
            score: 2,
            reson:'',
            backcontent:''
        }
    },
    components: { Radio, Input },
    created(){
        
    },
    mounted(){
        let vm = this;
    },
    methods:{
        ok(){
            let vm = this;            
            Axios.post('/sxerp/pt/erpservice/crmworkorderissue/markFinashAndScore', {
                params: {
                    pkid:vm.data,
                    score:vm.score,
                    backcontent:vm.backcontent
                }
            },{
                headers:{
                    'Content-Type':'application/json'
                }
            }).then(res => {
                    if (res.status) {                            
                    Message.info({title:'提示',message: '标记成功！',type:'success'});
                    vm.$emit('submit');
                }
            }).catch(err => {
                Message.info({title:'提示',message: '标记失败！',type:'error'});
            })
                
        },
        cancel(){
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss">
    .sign-wrap{
        line-height: 28px;
        .text{
            font-weight: bold;
            color:#333;
        }
        .choose{
            padding-left:20px;
            .el-textarea{
                margin-top:15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ProjectManage/sign.vue